import type { GDPRTranslations } from '../../types';

interface Props {
  hasCustomTermsOfService?: string;
  defaultTOSConsentValue: boolean;
  gdprTranslations?: GDPRTranslations;
}

const GDPRCompliance = ({
  hasCustomTermsOfService,
  defaultTOSConsentValue,
  gdprTranslations = {
    consentText: 'I consent to receive newsletters via email.',
    termsOfUseText: 'Terms of Use',
    privacyPolicyText: 'Privacy Policy',
    andText: 'and',
    consentTextVariantTwo: 'I consent to receive newsletters via Email. Signup',
    termsOfServiceText: 'Terms of Service',
  },
}: Props) => {
  return (
    <div className="flex w-full flex-row items-center space-x-2">
      <input
        type="checkbox"
        name="tos_consent"
        className="h-4 w-4 rounded border-gray-300"
        defaultChecked={defaultTOSConsentValue}
        style={{
          accentColor: 'var(--gdpr-checkbox-color)',
        }}
      />
      {!hasCustomTermsOfService ? (
        <p
          className="text-xs text-start font-medium"
          style={{
            color: 'var(--gdpr-text-color)',
          }}
        >
          {gdprTranslations.consentText}{' '}
          <a
            href="https://www.beehiiv.com/tou"
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.termsOfUseText}
          </a>{' '}
          {gdprTranslations.andText}{' '}
          <a
            href="https://www.beehiiv.com/privacy"
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.privacyPolicyText}
          </a>
          .
        </p>
      ) : (
        <p
          className="text-xs text-start font-medium"
          style={{
            color: 'var(--gdpr-text-color)',
          }}
        >
          {gdprTranslations.consentTextVariantTwo}{' '}
          <a
            href={hasCustomTermsOfService}
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.termsOfServiceText}
          </a>
          .
        </p>
      )}
    </div>
  );
};

export default GDPRCompliance;
